import { cn } from '@/lib/utils'
import type { AnchorHTMLAttributes } from 'react'

/**
 * Âncora com a aparência do `IconButton`, para URLs **externas**.
 *
 * O `IconButton` intercepta `href` e chama `navigate()` do react-router, o que
 * quebra link externo e descarta `target`/`rel`. Envolver o `IconButton` em um
 * `<a>` resolveria o comportamento, mas gera `<button>` dentro de `<a>` — HTML
 * inválido. Por isso a âncora é o próprio elemento clicável.
 */
export default function IconLink({
    className,
    ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
    return (
        <a
            className={cn(
                'inline-flex items-center justify-center rounded-full p-2',
                'text-foreground transition-colors hover:bg-accent',
                className,
            )}
            target="_blank"
            rel="external"
            {...props}
        />
    )
}
